import React, { useEffect, useState } from 'react'

import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import {
  actions as sitesActions,
  operations as sitesOperations,
} from '../../redux/sitesManager'
import { operations as reportOperations } from '../../redux/reports'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import Site from './component'
import {
  filterCanceledUsers,
  UpdateSiteUserNotifications,
} from '../../lib/util'

const SiteContainer = ({
  addBulkUsersResponse,
  clearSites,
  createSiteUser,
  createSiteUsers,
  deleteReports,
  error,
  fetchLessonProgressReport,
  fetchSiteUsers,
  fetchSites,
  fetchTrainingReport,
  isBulkOperationCompleted,
  isFetchingReports,
  isLoadingSite,
  isLoadingSiteUsers,
  push,
  remindSiteUser,
  remindSiteUsers,
  reports,
  resetBulkAddUsers,
  site,
  siteId,
  siteUsers,
  updateSiteUser,
}) => {
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedSite, setSelectedSite] = useState()
  const [selectedSiteId, setSelectedSiteId] = useState()

  function pushTo(url) {
    dispatch(push(url))
  }

  useEffect(() => {
    if (
      site === null &&
      !isLoadingSite &&
      (error === null || error === undefined)
    ) {
      fetchSites({ siteId })
    }
    if (siteUsers === null && !isLoadingSiteUsers && error === null) {
      fetchSiteUsers(siteId)
    }
    setSelectedSiteId(siteId)
    return function cleanup() {
      deleteReports()
    }
  }, [])

  // update
  useEffect(() => {
    // setting selectedSiteId
    if (siteId && siteId !== selectedSiteId) {
      setSelectedSiteId(siteId)
    } else if (!siteId && !selectedSiteId && site) {
      const enforcedId = site[0].id
      setSelectedSiteId(enforcedId)
      pushTo(`/css-admin/sites/${enforcedId}`)
      return
    }

    // setting selectedSite
    if (site && selectedSiteId === siteId) {
      if (!site) {
        setSelectedSite(null)
        return
      }
      setSelectedSite(site)
      fetchSiteUsers(site.id)
    }
  }, [selectedSiteId, site])

  const onSiteChange = e => {
    const { value } = e
    const siteId = value.id || {}
    const isDifferentSite = siteId !== selectedSiteId

    if (isDifferentSite) {
      setSelectedSiteId(siteId)
      pushTo(`/css-admin/sites/${siteId}`)
    }
  }

  const backToSearch = () => {
    clearSites()
    push('/css-admin/sites')
  }

  const toggleEditModal = () => setShowEditModal(!showEditModal)

  const isLoading = isLoadingSite || isLoadingSiteUsers

  const handleGrantNewRole = (siteUser, newRole) =>
    updateSiteUser(
      { ...siteUser, roles: [newRole] },
      UpdateSiteUserNotifications.grantNewRole,
    )

  const handleCancelUserAccess = siteUser =>
    updateSiteUser(
      { ...siteUser, isActive: false },
      UpdateSiteUserNotifications.removeUser,
    )

  return (
    <ErrorBoundary>
      <Loading isLoading={isLoading} message="Loading Site" />
      <Site
        addBulkUsersResponse={addBulkUsersResponse}
        backToSearch={backToSearch}
        createSiteUser={createSiteUser}
        createSiteUsers={createSiteUsers}
        error={error}
        fetchLessonProgressReport={fetchLessonProgressReport}
        fetchTrainingReport={fetchTrainingReport}
        handleCancelUserAccess={handleCancelUserAccess}
        handleGrantNewRole={handleGrantNewRole}
        isBulkOperationCompleted={isBulkOperationCompleted}
        isFetchingReports={isFetchingReports}
        onSiteChange={onSiteChange}
        remindSiteUser={remindSiteUser}
        remindSiteUsers={remindSiteUsers}
        reports={reports}
        resetBulkAddUsers={resetBulkAddUsers}
        selectedSite={selectedSite}
        showEditModal={showEditModal}
        site={site}
        siteId={siteId}
        siteUsers={filterCanceledUsers(siteUsers)}
        toggleEditModal={toggleEditModal}
      />
    </ErrorBoundary>
  )
}

const mapStateToProps = (
  { sitesManager, reportsManager, userManager },
  { match },
) => {
  const error = sitesManager.error
  const siteId = parseInt(match.params.id, 10)
  const sites = sitesManager.sites.data || []
  const site = sites.find(site => site.id === siteId) || null
  const sitesUsers = sitesManager.siteUsers.data || {}
  const siteUsers = sitesUsers[siteId] || null
  return {
    error,
    isLoadingSite: sitesManager.sites.isLoading,
    isLoadingSiteUsers: sitesManager.siteUsers.isLoading,
    isBulkOperationCompleted: sitesManager.siteUsers.isBulkOperationCompleted,
    addBulkUsersResponse: sitesManager.siteUsers.addBulkUsersResponse,
    isFetchingReports: reportsManager.isFetching,
    reports: reportsManager.reports,
    siteId,
    site,
    siteUsers,
  }
}

const mapDispatchToProps = {
  ...sitesActions,
  ...sitesOperations,
  ...reportOperations,
  remindSiteUser: sitesOperations.remindSiteUser,
  updateSiteUser: sitesOperations.updateSiteUser,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteContainer)



// WEBPACK FOOTER //
// ./src/components/Site/container.js